import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from "../../Display/Button/Button";
import SignaturePad from "./components/SignaturePad";
import "./Signature.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function Signature(_ref) {
  let {
    showSignatureMessage,
    handleSignatureEnd
  } = _ref;
  const [signature, setSignature] = useState();
  const inputRef = useRef(null);
  useEffect(() => {
    const newSignature = new SignaturePad({
      minWidth: 1,
      onEnd: () => {
        handleSignatureEnd(newSignature.toDataURL());
      }
    });
    newSignature.initialize();
    setSignature(newSignature);

    // Sometimes the signature pad initializes before the container is displayed.
    setTimeout(() => {
      const resizeEvent = new Event('resize');
      window.dispatchEvent(resizeEvent);
    }, 250);
  }, [handleSignatureEnd]);
  const clearSignature = () => {
    handleSignatureEnd(null);
    signature.clear();
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };
  const drawSignature = e => {
    signature.drawSignature(e);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showSignatureMessage && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "fRpR0P",
          description: "client-guardian-sign-below",
          defaultMessage: "Client or Personal Representative/Guardian (if applicable) please sign in the box below:",
          children: txt => /*#__PURE__*/_jsx("strong", {
            children: txt
          })
        })
      }), /*#__PURE__*/_jsx("input", {
        "aria-label": "Type your signature here",
        style: {
          fontFamily: 'Style Script'
        },
        onChange: drawSignature,
        tabIndex: 0,
        ref: inputRef,
        type: "text",
        id: "type-signature",
        name: "type-signature"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        position: 'relative'
      },
      children: [/*#__PURE__*/_jsx("div", {
        id: "signature-pad",
        className: "m-signature-pad",
        children: /*#__PURE__*/_jsx("div", {
          className: "m-signature-pad--body",
          children: /*#__PURE__*/_jsx("canvas", {
            id: "signature-canvas",
            "data-testid": "signature-canvas"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "reset",
        style: {
          paddingBottom: '40px'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "kaVy/M",
          description: "clear-signature-text",
          defaultMessage: "Clear Signature",
          children: txt => /*#__PURE__*/_jsx(Button, {
            type: "button",
            link: true,
            label: txt,
            onClick: clearSignature
          })
        })
      })]
    })]
  });
}
Signature.propTypes = {
  /* Should display signature message ? */
  showSignatureMessage: PropTypes.bool,
  /* It is invoked after the user has entered his signature */
  handleSignatureEnd: PropTypes.func
};
//# sourceMappingURL=Signature.js.map